import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useResetPassword } from '../hooks/useResetPassword'
import Loader from './Loader'

const ResetPassword = () => {
    const location = useLocation()
    const initialEmail = location.state?.email || ''
    const [email, setEmail] = useState(initialEmail)
    const [otp, setOtp] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const {resetPassword, error, isLoading} = useResetPassword()

    const handleSubmit = async (e) => {
        e.preventDefault()
        await resetPassword(email, otp, newPassword, confirmPassword)
    }

    if (isLoading) {
        return <Loader />
    }

    return (
        <div className="reset-password-container">
            <form className="reset-password" onSubmit={handleSubmit}>
                <h3>Reset Password</h3>
                <div className="reset-password-input-section">
                    <label>Email address:</label>
                    <input class="reset-email-input" type="email" onChange={(e) => setEmail(e.target.value)} value={email} />
                    <label>Password Reset Code (sent to email):</label>
                    <input class="reset-code-input" type="text" onChange={(e) => setOtp(e.target.value)} value={otp} />
                    <label>New Password: </label>
                    <input class="reset-password-input" type="password" onChange={(e) => setNewPassword(e.target.value)} value={newPassword} />
                    <label>Confirm New Password: </label>
                    <input class="reset-confirm-password-input" type="password" onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword} />
                </div>
                <button disabled={isLoading}>Submit</button>
                {error && <div className="error">{error}</div>}
            </form>
        </div>
    )
}

export default ResetPassword